// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promo-code__text[data-v-2a2931f4]{color:#fff;background:#7e2182;font-family:var(--brand-font-bold);font-size:.75rem;line-height:1rem;padding:.25rem;margin:0 0 rem-cacl(8);border-radius:.25rem}@media only screen and (min-width:40.0625rem){.promo-code__text[data-v-2a2931f4]{padding:.375rem .625rem}}.promo-code svg[data-v-2a2931f4]{fill:#fff;margin-bottom:-.1875rem;height:.8125rem}", ""]);
// Exports
module.exports = exports;
